import { render, staticRenderFns } from "./MenuCommonSub.vue?vue&type=template&id=e0c81a80&scoped=true"
import script from "./MenuCommonSub.vue?vue&type=script&lang=js"
export * from "./MenuCommonSub.vue?vue&type=script&lang=js"
import style0 from "./MenuCommonSub.vue?vue&type=style&index=0&id=e0c81a80&prod&lang=scss&scoped=true"
import style1 from "./MenuCommonSub.vue?vue&type=style&index=1&id=e0c81a80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c81a80",
  null
  
)

export default component.exports